import type { IconSvgObject } from './types';

const EthereumEllipseIcon: IconSvgObject = [
  ["path", { d: "M15.4912 12.1908L12 13.5L8.50883 12.1908M8 12L12 6L16 12L12 18L8 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default EthereumEllipseIcon;
